import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultMemberRewardListAssets = {
    noRewardsIconName: 'member-reward-info-message',
    failedToLoadDataIconName: 'generic-error-message',
    actionButtonListItemIconName: 'chevron-right'
};
export const memberRewardListAssetsValidator = Validator.object({
    noRewardsIconName: nonEmptyStringValidator,
    failedToLoadDataIconName: nonEmptyStringValidator,
    actionButtonListItemIconName: nonEmptyStringValidator
});
